module.exports = __webpack_public_path__ + "assets/img/6_520.52017e71.jpg";